export const GET_MESSAGE_PENDING = 'GET_MESSAGE_PENDING'
export const GET_MESSAGE_SUCCESSFUL = 'GET_MESSAGE_SUCCESSFUL'
export const GET_MESSAGE_ERROR = 'GET_MESSAGE_ERROR'
export const GET_ATTACHMENT_PENDING = 'GET_ATTACHMENT_PENDING'
export const GET_ATTACHMENT_SUCCESSFUL = 'GET_ATTACHMENT_SUCCESSFUL'
export const GET_ATTACHMENT_ERROR = 'GET_ATTACHMENT_ERROR'



